import { Link } from '@tanstack/react-router'
import { useTranslations } from '@utils/i18n-to-migrate/useTranslations'

export const NotFound = () => {
  const { t } = useTranslations()
  return (
    <div>
      <h1>{t('notfound.title')}</h1>
      <p>{t('notfound.notFound')}</p>

      <Link to="/">{t('notfound.goHome')}</Link>
    </div>
  )
}
